const HidroYPetroRules = (data = {}) => {
  let TipoPermiso = data.TipoPermiso;

  // PER01	Expendio en estaciones de servicio de petrolíferos	PL/(N°Consecutivo)/EXP/ES/(Año)	PL/[0-9]{3,20}/EXP/ES/[0-9]{4}
  // PER02	Comercialización	H/(N°Consecutivo)/COM/(Año)	H/[0-9]{3,24}/COM/[0-9]{4}
  // PER03	Distribución por otros medios distintos a ducto	PL/(N°Consecutivo)/DIS/OM/(Año)	PL/[0-9]{3,20}/DIS/OM/[0-9]{4}
  // PER04	Expendio en estaciones de servicio multimodal de petrolíferos	PL/(N°Consecutivo)/EXP/ES/MM/(Año)	PL/[0-9]{3,17}/EXP/ES/MM/[0-9]{4}
  // PER05	Expendio en estaciones de servicio de petrolíferos	CNE/PL/(N°Consecutivo)/EXP/ES/(Año)	CNE/PL/[0-9]{3,16}/EXP/ES/[0-9]{4}
  // PER06	Comercialización	CNE/H/(N°Consecutivo)/COM/(Año)	CNE/H/[0-9]{3,20}/COM/[0-9]{4}
  // PER07	Distribución por otros medios distintos a ducto	CNE/PL/(N°Consecutivo)/DIS/OM/(Año)	CNE/PL/[0-9]{3,16}/DIS/OM/[0-9]{4}
  // PER08	Expendio en estaciones de servicio multimodal de petrolíferos	CNE/PL/(N°Consecutivo)/EXP/ES/MM/(Año)	CNE/PL/[0-9]{3,13}/EXP/ES/MM/[0-9]{4}
  // PER09	Comercialización	CNE/PL/(N°Consecutivo)/COM/(Año)	CNE/PL/[0-9]{3,19}/COM/[0-9]{4}
  // PER10	Comercialización	#[a-zA-Z0-9]	#[a-zA-Z0-9]{14}
  // PER11	Comercialización	F00.07.UH/(N°Consecutivo)/(Año)	F00\.07\.UH/[0-9]{3,20}/[0-9]{4}

  let regex = '';

  if (TipoPermiso === 'PER01') {
    regex = 'PL/[0-9]{3,20}/EXP/ES/[0-9]{4}';
  } else if (TipoPermiso === 'PER02') {
    regex = 'H/[0-9]{3,24}/COM/[0-9]{4}';
  } else if (TipoPermiso === 'PER03') {
    regex = 'PL/[0-9]{3,20}/DIS/OM/[0-9]{4}';
  } else if (TipoPermiso === 'PER04') {
    regex = 'PL/[0-9]{3,17}/EXP/ES/MM/[0-9]{4}';
  } else if (TipoPermiso === 'PER05') {
    regex = 'CNE/PL/[0-9]{3,16}/EXP/ES/[0-9]{4}';
  } else if (TipoPermiso === 'PER06') {
    regex = 'CNE/H/[0-9]{3,20}/COM/[0-9]{4}';
  } else if (TipoPermiso === 'PER07') {
    regex = 'CNE/PL/[0-9]{3,16}/DIS/OM/[0-9]{4}';
  } else if (TipoPermiso === 'PER08') {
    regex = 'CNE/PL/[0-9]{3,13}/EXP/ES/MM/[0-9]{4}';
  } else if (TipoPermiso === 'PER09') {
    regex = 'CNE/PL/[0-9]{3,19}/COM/[0-9]{4}';
  } else if (TipoPermiso === 'PER10') {
    regex = '#[a-zA-Z0-9]{14}';
  } else if (TipoPermiso === 'PER11') {
    regex = 'F00\\.07\\.UH/[0-9]{3,20}/[0-9]{4}';
  }

  return {
    TipoPermiso: ['required', 'string'],
    NumeroPermiso: ['required', 'string', 'min:15', 'max:35', `regex:/${regex}/`],
    ClaveHYP: ['required', 'string'],
    SubProductoHYP: ['required', 'string'],
  };
};

export default HidroYPetroRules;
